import { IGetCheckoutDataResult } from './types';

export const DEFAULT_RESULT: IGetCheckoutDataResult = {
  balance: 0,
  totalAmount: 0,
};
